import { Controller } from "@hotwired/stimulus"

// This controller submits a checkbox's VALUE attribute when checked,
// or an empty string when unchecked. This is useful for integer fields
// that use checkboxes to set/clear values (like featured_page_order).
//
// Unlike checkbox_submitter_controller which always sends "1" or "0",
// this sends the actual checkbox value attribute.
//
// Example:
//   <input type="checkbox"
//          name="playlist[featured_page_order]"
//          value="99"
//          data-controller="checkbox-value-submitter"
//          data-checkbox-value-submitter-path-value="/admin/playlists/123"
//          data-action="change->checkbox-value-submitter#updateRemote">
//
// When checked: sends { playlist: { featured_page_order: "99" } }
// When unchecked: sends { playlist: { featured_page_order: "" } }

// Connects to data-controller="checkbox-value-submitter"
export default class extends Controller {
  static values = {
    path: String,
    method: { type: String, default: 'PATCH' }
  }

  updateRemote(event) {
    const checkbox = event.target
    const name = checkbox.name
    const md = name.match(/^(\w+)\[(\w+)\]$/)
    if (!md) {
      throw new Error("Checkbox name must be of the form model[attribute]")
    }
    const model = md[1]
    const attribute = md[2]

    // Send the checkbox's value when checked, empty string when unchecked
    const value = checkbox.checked ? checkbox.value : ''

    const data = new FormData()
    data.append(name, value)

    const csrfToken = document.getElementsByTagName('meta')['csrf-token'].content;

    fetch(this.pathValue, {
      method: this.methodValue,
      body: data,
      mode: 'cors',
      credentials: 'same-origin',
      headers: {
        "X-CSRF-Token": csrfToken,
        "Accept": "application/json"
      }
    }).then(response => {
      if (!response.ok) {
        throw new Error("Network response was not ok")
      }
      return response.json()
    }).then(data => {
      // Update checkbox based on whether the attribute has a value
      // If the server returns a truthy value for the attribute, check it
      checkbox.checked = !!data[attribute]
    }).catch(error => {
      console.error("Error updating checkbox:", error)
      alert("There has been a problem updating the checkbox: " + error)
      // Revert checkbox state on error
      checkbox.checked = !checkbox.checked
    })
  }
}
